import { useRef, useState } from "react";
import { BlogShare } from "@features/blog";
import { useEscapeKey } from "@shared/lib/hooks/useEscapeKey";
import { useOutsideClick } from "@shared/lib/hooks/useOutsideClick";
import { ShareIcon } from "@shared/ui/Icon/ui/Socials/ShareIcon";
import classes from "./blog-share-toggle.module.scss";

export const BlogShareToggle = () => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const toggle = () => setIsOpen((prev) => !prev);

    useOutsideClick(ref, () => setIsOpen(false));
    useEscapeKey(() => setIsOpen(false));

    return (
        <div className={classes["share-toggle"]} ref={ref}>
            <button
                className={classes["share-toggle__button"]}
                onClick={toggle}
                aria-label="Поделиться"
            >
                <ShareIcon />
            </button>

            {isOpen && (
                <div className={classes["share-toggle__popover"]}>
                    <BlogShare />
                </div>
            )}
        </div>
    );
};